import React from 'react';
import ReactDOM from 'react-dom';
import injectTapEventPlugin from 'react-tap-event-plugin';
import jss from 'jss';
import preset from 'jss-preset-default';

require('../less/main.less'); // FOR WEBPACK
import configureStore from './configureStore';
import Root from './root';

jss.setup(preset());

const store = configureStore();
injectTapEventPlugin();


ReactDOM.render(
  <Root store={store} />,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/app/app.jsx